const terminationMutualAgreement = `
    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="https://www.fcamara.com.br/images/marcas-mercados/slide/omnik.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>DISTRATO DE CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE INFORMÁTICA</strong></p>
            </td>
        </tr>
        <tr>
            <td>
            <div class="main">

                <p>
                     Pelo presente instrumento, e na melhor forma de direito, de um lado, <strong>OMNIK SERVIÇOS DE TECNOLOGIA DA INFORMAÇÃO LTDA</strong>, regularmente inscrita no CNPJ/MF sob o nº 33.575.991/0001-90, com sede na Rua Bela Cintra, 986, 2º andar, CEP 01415-906, Consolação - São Paulo/SP, doravante designado CONTRATANTE. E, de outro <strong>{{companyname}}</strong>, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº{{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, neste ato representada por {{consultantname}}, brasileiro(a), {{consultantcivilstatus}}, possuidor do RG nº {{consultantrg}}, inscrito no CPF/MF sob o nº {{consultantcpf}}, residente e domiciliado {{consultantaddress}}, nº {{consultantnumber}}, CEP.{{consultantcep}}, {{consultantcity}}/{{consultantstate}}, doravante designada <strong>CONTRATADA</strong>.
                </p>

                <!-- CORPO DO DOCUMENTO -->

                <p>
                    Decidem de comum e mútuo acordo, rescindir nesta data o <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM INFORMÁTICA</strong> firmado em <strong>{{contractstart}}</strong>
                </p>

                <p>
                    As partes declaram que o pagamento referente à contraprestação pecuniária aos serviços de consultoria prestados, será realizado em até 15 (quinze) dias corridos, contados da data de assinatura por ambas as PARTES deste instrumento, observando os critérios essenciais de: emissão de nota fiscal e entrega dos equipamentos em comodato no momento da assinatura do contrato.
                </p>

                <p>
                    A CONTRATADA declara que houve a devolução de todos os equipamentos da CONTRATANTE, que estavam em sua posse, na sede da CONTRATANTE, qual seja o endereço: Rua Bela Cintra, 986, 2º andar, CEP 01415-906, Consolação - São Paulo/SP. Caso os equipamentos não tenham sido entregues em sua totalidade, ou ainda, contenham problemas de mau uso ou avarias, mediante verificação da assistência técnica, ocorrerá o desconto dos valores apurados, pelos danos aos equipamentos.
                </p>

                <p>
                    E, por estarem, assim, justos e contratados, firmam o presente instrumento, dando plena e clara quitação, nos moldes e prazos mencionados acima, juntamente com 2 (duas) testemunhas.
                </p>

                <p>
                    As Partes desde já acordam, que o presente Contrato será assinado eletronicamente, via plataforma Docusign, cuja validade para todos os fins é reconhecida pelos signatários, nos termos do artigo 10º, §2º, da MP 2.200-2/2001.
                </p>

                <p>
                    As partes convencionam que, qualquer controvérsia relativa à interpretação ou execução do presente contrato, ou de qualquer forma oriunda ou associada a ele, e que não seja resolvida de forma amigável entre as Partes, deverá ser dirimida de forma definitiva por Arbitragem, nos termos da Lei ° 9.307/96.
                </p>

                <br>
                </td>
                </tr>
                <tr>
                <td align="center" height='60px'>
                <p style="text-align: center; margin-top: 50px;">
                    <strong>São Paulo</strong>, {{contractend}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>OMNIK SERVIÇOS DE TECNOLOGIA DA INFORMAÇÃO LTDA</strong>
                        <br>
                        <strong>CONTRATANTE</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{companyname}}<br>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
        </tr>
    </table>
`;

export default terminationMutualAgreement;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/docusignDocumentTemplates/terminationMutualAgreement.ts